export default __webpack_public_path__ + "static/home-page-bio-6-9d7d94a866d1343380e818881afc2c90.webp";